// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__wmbDR","requiredAsterisk":"Info_requiredAsterisk__1fsDd"};